import { useState } from 'react';
import { FaQuestionCircle, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQ = () => {
  const faqs = [
    {
      question: "What are the eligibility criteria for loans?",
      answer: "Applicants must be between 21-55 years old. Salaried individuals need a minimum monthly income, while business owners need to provide business details."
    },
    {
      question: "What documents are required for the loan application?",
      answer: "You'll need to provide basic personal details, income proof (salary slips or ITR), and bank statements for the last 12 months."
    },
    {
      question: "How long does the approval process take?",
      answer: "We aim to review all applications and respond within 1-2 business days. Some profiles may receive a faster response."
    },
    {
      question: "Can I apply if I'm self-employed?",
      answer: "Yes, we have special loan products for business owners and self-employed individuals."
    }
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <div className="glass-container">
        <h1><FaQuestionCircle style={{ marginRight: '15px', color: 'var(--federal-blue)' }} /> Frequently Asked Questions</h1>
        <p className="faq-subtitle">Find answers to common questions about our loan services</p>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
              <div 
                className="faq-question" 
                onClick={() => toggleFAQ(index)}
              >
                <span className="question-text">{faq.question}</span>
                <span className="toggle-icon">
                  {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </div>
              {activeIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;